// src/Work.js
import React from 'react';
import './Work.css';

import thumbAttention from './assets/attention_thumbnail.png';
import hivethumb from './assets/the_hive_next_door_thumb.png';
import kayaThumb from './assets/kayaThumb.png';
import goThumb from './assets/goThumb.png';
import visualsThumb from './assets/visualsThumb.png';
import bloomThumb from './assets/bloomThumb.png';

// Inline projects data
const projects = [
   {
    id: 1,
    type: 'video',
    title: 'in full bloom',
    date: 'Dec 2025',
    external: false,
    thumb: bloomThumb,
    vimeo: 'https://player.vimeo.com/video/1147572280',
    info: 'Filmed and edited',
  },
   {
    id: 2,
    type: 'video',
    title: 'visuals...',
    date: 'Dec 2025',
    external: false,
    thumb: visualsThumb,
    vimeo: 'https://player.vimeo.com/video/1147208889',
    info: 'Filmed and edited',
  },
    {
    id: 3,
    type: 'video',
    title: 'WATCH ME GO! (spec)',
    date: 'Dec 2025',
    external: false,
    thumb: goThumb,
    vimeo: 'https://player.vimeo.com/video/1146729735',
    info: 'Spec',
  },
  {
    id: 4,
    type: 'video',
    title: 'The Hive Next Door',
    date: 'June 2025',
    external: false,
    thumb: hivethumb,
    vimeo: 'https://player.vimeo.com/video/1099789917',
    info: 'Filmed & edited for The Hive Next Door',
  },
  {
    id: 5,
    type: 'video',
    slug: 'attention',
    title: 'Attention',
    date: 'June 2025',
    external: false,
    thumb: thumbAttention,
    vimeo: 'https://player.vimeo.com/video/1095340693',
    info: 'Filmed & edited',
  },
  {
    id: 6,
    type: 'video',
    title: 'Introducing Kaya',
    date: 'June 2025',
    external: false,
    thumb: kayaThumb,
    vimeo: 'https://player.vimeo.com/video/1134921901',
    info: 'Filmed & edited',
  },
];

export default function Work() {
  const handleProjectClick = (project) => {
    if (project.external && project.url) {
      window.open(project.url, '_blank', 'noopener,noreferrer');
      return;
    }

    if (project.vimeo) {
      const cleanVimeo = project.vimeo.replace('player.', '');
      window.open(cleanVimeo, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="work-container">
      <h1 className="work-page-title">Work</h1>

      <div className="gallery">
        {projects.map((p) => (
          <button
            key={p.id}
            type="button"
            className="gallery-item"
            onClick={() => handleProjectClick(p)}
            aria-label={p.title}
          >
            <img src={p.thumb} alt={p.title} className="thumb" />
          </button>
        ))}
      </div>

      {/* ─── FOOTER ───────────────────────────────── */}
      <footer className="site-footer">
        <div className="footer-inner">
          <nav className="footer-nav">
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
            <a href="/blog">Blog</a>
          </nav>
          <p className="footer-legal">
            © {new Date().getFullYear()} Kaya Visuals · Austin, TX
          </p>
        </div>
      </footer>
    </section>
  );
}
